export interface FeaturedNonprofit {
  name: string
  tagline: string
  taglineEs?: string
  url?: string
  accentColor: string
  bgColor: string
  emoji: string
  logoUrl?: string
}

export const featuredNonprofits: FeaturedNonprofit[] = [
  {
    name: 'Educate 2 Envision',
    tagline: 'Reimagine Rural Education',
    taglineEs: 'Reimaginar la Educación Rural',
    url: 'https://www.educate2envision.org/',
    accentColor: 'text-haa-blue',
    bgColor: 'bg-white',
    emoji: '📚',
    logoUrl:
      'https://cdn.magicpatterns.com/uploads/ev4kbKkWLnh6RaghTq6B2v/Screenshot_2026-03-02_at_10.40.07_PM.png',
  },
  {
    name: 'Leadership Mission International',
    tagline: 'Developing leaders for global impact',
    taglineEs: 'Desarrollando líderes para impacto global',
    url: 'https://leadershipmission.org/',
    accentColor: 'text-haa-blue',
    bgColor: 'bg-white',
    emoji: '🌍',
    logoUrl:
      'https://cdn.magicpatterns.com/uploads/u4EMTZoVEvHirbk4cRDwqL/Screenshot_2026-03-02_at_1.33.52_AM.png',
  },
  {
    name: 'Honduras Outreach International',
    tagline: 'Strengthening communities in Honduras',
    taglineEs: 'Fortaleciendo comunidades en Honduras',
    url: 'https://hoi.org/',
    accentColor: 'text-haa-midblue',
    bgColor: 'bg-white',
    emoji: '🤲',
    logoUrl:
      'https://cdn.magicpatterns.com/uploads/1Hkzbv9krJHVeCJsoZKFjV/Screenshot_2026-03-02_at_1.35.08_AM.png',
  },
  {
    name: '1,000 Schools Honduras',
    tagline: 'Education & youth empowerment',
    taglineEs: 'Educación y empoderamiento juvenil',
    url: 'https://onethousandschools.com/',
    accentColor: 'text-sky-500',
    bgColor: 'bg-white',
    emoji: '🏫',
    logoUrl:
      'https://cdn.magicpatterns.com/uploads/ctxHhUcNgPAM92U4bemBcp/otc_shh_logo.png',
  },
  {
    name: 'Honduras Good Works',
    tagline: 'Transforming communities through service',
    taglineEs: 'Transformando comunidades a través del servicio',
    url: 'https://hondurasgoodworks.org/',
    accentColor: 'text-emerald-700',
    bgColor: 'bg-white',
    emoji: '⛰️',
    logoUrl:
      'https://cdn.magicpatterns.com/uploads/siGs9qNXo2q2xfXApgtsjZ/HGW-Logo_Main-Color.webp',
  },
  {
    name: 'Young Life Honduras',
    tagline: 'Reaching young people for Christ',
    taglineEs: 'Alcanzando jóvenes para Cristo',
    url: 'https://honduras.younglife.org/',
    accentColor: 'text-lime-600',
    bgColor: 'bg-[#1e2d4a]',
    emoji: '🌱',
    logoUrl:
      'https://cdn.magicpatterns.com/uploads/seGgtTTq8VBPFyAiC9dmg7/Screenshot_2026-03-02_at_1.37.01_AM.png',
  },
]
